export var IGUMPendingState;
(function (IGUMPendingState) {
    IGUMPendingState[IGUMPendingState["PENDING_UNMUTE"] = 1] = "PENDING_UNMUTE";
    IGUMPendingState[IGUMPendingState["NONE"] = 2] = "NONE";
})(IGUMPendingState || (IGUMPendingState = {}));
